/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Promos_DescriptionInputs */



/**
* | output |
* | --- |
* | "Alternate printings from events and giveaways" |
*
* @param {Nav_Promos_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_promos_description = /** @type {((inputs?: Nav_Promos_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Promos_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alternative Drucke aus Events und Giveaways")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impressions alternatives issues d'événements et de giveaways")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("来自活动和赠品的特殊印刷版本")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("來自活動與贈品的其他印刷版本")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이벤트와 증정품으로 나온 대체 인쇄판")
	return /** @type {LocalizedString} */ ("Alternate printings from events and giveaways")
});